import { Modal as ModalComp } from "antd";

const Modal = ({
  title = "Vertically centered modal dialog",
  open,
  onOk,
  onCancel,
  children,
  centered = true,
  confirmLoading,
  footer,
  maskClosable = true,
  width,

}: {
  title?: string;
  open: boolean;
  onOk?: () => void;
  onCancel?: () => void;
  children: React.ReactNode;
  centered?: boolean;
  confirmLoading?: boolean;
  footer?: any;
  maskClosable?: boolean;
  width?: string;

}) => {
  return (
    <ModalComp
      title={title}
      centered={centered}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      footer={footer}
      maskClosable={maskClosable}
      width={width}
 
     
    >
      {children}
    </ModalComp>
  );
};

export default Modal;
